<template>
  <a-table
    ref="table"
    size="middle"
    bordered
    rowKey="id"
    :columns="columns"
    :dataSource="dataSource"
    :pagination="false"
    :loading="loading"
  >
        <span slot="action" slot-scope="text, record">
        <a @click="handleDownload(record)">下载</a>
        </span>
  </a-table>
</template>

<script>
import {downloadFile, getAction} from "@api/manage";

export default {
  name: "SubmittedDocuments",
  data(){
    return {
      url:{
        list:"/ebid-ce/file/list",
        minioDownload: "/ebid-ce/file/minioDownload",
      },
      dataSource:[],
      loading: false,
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '文件名称',
          align: "center",
          dataIndex: 'fileName'
        },
        {
          title: '文件类型',
          align: "center",
          dataIndex: 'typeZh'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          scopedSlots: {customRender: 'action'},
        }
      ],
    }
  },
  created() {
    this.loadData()
  },
  methods:{
    //查询已提交文件信息
    loadData(id) {
      if(!this.url.list || !id){
        //this.$message.error("请设置url.list属性!")
        return
      }
      let params = {} ;//查询条件
      params.bidId = id;
      params.pageSize = 200;
      params.type = 'signReceiptFile,projectApprovalDoc,agentRecordOrEntrust,tenderBusiLicense,sectionDivideTable,otherSupplement,remoteEvaluationDoc,UnfixedInstructionStamp';
      this.loading = true;
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          let list = res.result.records||res.result;
          this.dataSource = list;
        }
        this.loading = false;
      })
    },
    handleDownload(rec) {
      var that = this;
      getAction(that.url.minioDownload,{id: rec.id}).then(res => {
        if(res.success) {
          console.log(res.result);
          downloadFile(res.result , rec.fileName);
        }
      })
    },
  }
}
</script>

<style scoped>

</style>